/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Totp_Not_PendingInputs */

const en_error_totp_not_pending = /** @type {(inputs: Error_Totp_Not_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This setup has expired. Start again.`)
};

/**
* | output |
* | --- |
* | "This setup has expired. Start again." |
*
* @param {Error_Totp_Not_PendingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_totp_not_pending = /** @type {((inputs?: Error_Totp_Not_PendingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Totp_Not_PendingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_totp_not_pending(inputs)
});